export const buildAllPreferences = (parselyCtx) => {
  const allUserPreferences = [
    ...parselyCtx.myTeam.state.userPreferences,
    ...parselyCtx.mySport.state.userPreferences,
    ...parselyCtx.myLocalNews.state.userPreferences,
  ];
  const allContentsByUserPreferences = [
    ...parselyCtx.mySport.state.contentsByUserPreferences.map((object) => ({
      ...object,
      htmlId: parselyCtx.mySport.widget.htmlId,
    })),
    ...parselyCtx.myTeam.state.contentsByUserPreferences.map((object) => ({
      ...object,
      htmlId: parselyCtx.myTeam.widget.htmlId,
    })),
    ...parselyCtx.myLocalNews.state.contentsByUserPreferences.map((object) => ({
      ...object,
      htmlId: parselyCtx.myLocalNews.widget.htmlId,
    })),
  ].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

  return [allUserPreferences, allContentsByUserPreferences];
};
